import { render } from "./customSlider.vue?vue&type=template&id=63eb377f&scoped=true"
import script from "./customSlider.vue?vue&type=script&lang=js"
export * from "./customSlider.vue?vue&type=script&lang=js"

import "./customSlider.vue?vue&type=style&index=0&id=63eb377f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb377f"]])

export default __exports__